import { useState, useEffect } from 'react';
import Button from 'components/base/Button';
import { withTheme } from 'react-jsonschema-form';
import LayoutField from 'react-jsonschema-form-layout-2';
import Bootstrap4Theme from 'react-jsonschema-form-bs4';
import { Col, Row, Alert } from 'react-bootstrap';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import LoadingOverlay from 'components/loading-overlay/LoadingOverlay';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { updateItemQuantity, getItem } from 'api/api';

function AddQuantity() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const Form = withTheme(Bootstrap4Theme);
  const [formData, setFormData] = useState();
  const [error, setError] = useState([]);
  const [loading, setLoading] = useState(false);
  const [itemName, setItemName] = useState(null);
  const [quantity, setQuantity] = useState(null);
  const { id } = useParams();
  const customState = state && state.customState;

  let breadcrumbItems = [];
  if (customState === 'stockItem') {
    breadcrumbItems = [
      {
        label: 'Items',
        url: `/weapons/weapons`
      },
      // {
      //   label: 'Weapon Stocks',
      //   url: `/weapons/stock-weapon/${id}`
      // },
      {
        label: 'Add Quantity',
        active: true
      }
    ];
  } else if (customState === 'itemDetails') {
    breadcrumbItems = [
      {
        label: 'Weapon Details',
        url: `/weapons/weapon-details/${id}`
      },
      {
        label: 'Add Quantity',
        active: true
      }
    ];
  }

  useEffect(() => {
    loadItem();
  }, []);

  const loadItem = () => {
    setError([]);
    setLoading(true);

    getItem(id)
      .then(async response => {
        const data = response.data.data;

        setItemName(data.name);
        setQuantity(data.quantity);
      })
      .catch(err => {
        try {
          setError(err.response.data.errors);
        } catch (ex) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  const handleSubmit = ({ formData }) => {
    setError([]);
    setFormData(formData);
    setLoading(true);

    console.log(formData);

    updateItemQuantity(id, formData)
      .then(response => {
        if (response.status === 200) {
          if (customState === 'stockItem') navigate('/weapons/weapons');
          if (customState === 'itemDetails')
            navigate('/weapons/weapon-details/' + id);
        }
      })
      .catch(err => {
        console.log(err);
        try {
          setError(err.response.data.errors);
        } catch (error) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  const schema = {
    type: 'object',
    required: ['quantity'],
    properties: {
      quantity: {
        title: 'Quantity',
        type: 'number',
        minimum: 0
      }
    }
  };

  const uiSchema = {
    'ui:field': 'layout',
    name: {
      'ui:autofocus': true
    },

    'ui:layout': [{ quantity: { md: 8 } }]
  };

  const fields = {
    layout: LayoutField
  };

  const handleGoBack = () => {
    if (customState === 'stockItem') navigate('/weapons/weapons/');
    if (customState === 'itemDetails')
      navigate('/weapons/weapon-details/' + id);
  };

  return (
    <div>
      <PageBreadcrumb items={breadcrumbItems} />
      <div className="mb-9">
        <div className="d-flex flex-wrap gap-3 flex-between-end mb-5">
          <div>
            <h2 className="mb-2">{`Add quantity for '${itemName}'`}</h2>
            <h5 className="text-700 fw-semi-bold">{`Available quantity: ${quantity}`}</h5>
          </div>
        </div>
        <Row className="g-5">
          <Col xs={12} xl={8}>
            <div>
              <div>
                {Object.entries(error).length > 0 &&
                  error.map((e, index) => (
                    <Alert variant="soft-danger" key={index}>
                      {e}
                    </Alert>
                  ))}
              </div>

              {loading && <LoadingOverlay />}

              <Form
                schema={schema}
                uiSchema={uiSchema}
                fields={fields}
                onSubmit={handleSubmit}
                formData={formData}
                showErrorList={false}
              >
                <div
                  className="d-flex flex-wrap gap-2"
                  style={{ marginTop: '10px' }}
                >
                  <Button variant="primary" type="submit">
                    Submit
                  </Button>
                  <Button
                    variant="phoenix-secondary"
                    type="button"
                    onClick={() => handleGoBack()}
                  >
                    Discard
                  </Button>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default AddQuantity;
